var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgreeHabeasData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.8535 6.8535C4.756 6.951 4.628 7 4.5 7C4.372 7 4.244 6.951 4.1465 6.8535L2.1465 4.8535C1.951 4.658 1.951 4.342 2.1465 4.1465C2.342 3.951 2.658 3.951 2.8535 4.1465L4.5 5.793L8.675 1.618C7.7615 0.6255 6.4555 0 5 0C2.2385 0 0 2.2385 0 5C0 7.7615 2.2385 10 5 10C7.7615 10 10 7.7615 10 5C10 4.0575 9.7345 3.179 9.281 2.426L4.8535 6.8535Z",
    fill: "#A1D23F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreeHabeasData);
export default __webpack_public_path__ + "static/media/agreeHabeasData.acd4ababb9b57492f2d273c180babae9.svg";
export { ForwardRef as ReactComponent };